import TextInput from "../../../form/TextInput";
import React from "react";

export default (propsTop) => {
    const {props, state, parent} = propsTop;
    const {hidden, labels, pool, operationitems, actionButtons} = props;
    return (hidden || []).indexOf("discount") === -1 && <div className="row form-row">
        <div className="col-sm-12">
            <TextInput
                style={{backgroundColor: "rgba(255,0,0,.2)"}}
                type={"decimal"}
                disabled={props.isLoading}
                value={(props.values.xtradata || {}).discount}
                label="Eltérő kedvezmény"
                saveChanges={(field, discount) => props.setFieldValue("xtradata.discount", discount)}
            />
        </div>
    </div>;
}